module.exports = __webpack_public_path__ + "static/Facebook_Platform_Mockup-2e7f23e8642b85d67bd854e1a82c07fb.jpg";